// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-chat-label{padding-bottom:8px}.c-chat-label__container{display:flex;flex-direction:column;align-items:center;justify-items:center;color:#347f4d;height:14px;margin:18px 0}.c-chat-label__container hr{margin-top:-8px;width:100%;border-top:1px solid #347f4d;border-color:#347f4d;border-bottom:0}.c-chat-label__text{background:#fff;z-index:1;padding:0 8px;font-size:.875rem}", ""]);
// Exports
module.exports = exports;
